export class CustomLogo {

    has_custom_logo: boolean = false;
    custom_logo_id: string;


    hasSecondaryLogo: boolean = false;
    secondaryLogoCMId: string;
    

    hideText: boolean = false;
    has_custom_logo_on_every_page: boolean = false;
    stretchTillTop: boolean = false;
    hasDarkBackground: boolean = false;
    
    // custom_logo_type: string = null;
    
    custom_logo_tint_color: string = null;
    custom_logo_has_tint: boolean = false;

    widthIos: number = null;

}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/customlogo.ts